<template>
    <div>
        <h1>Claimants</h1>
        <ul>
            <li v-for="claimant in claimants" :key="claimant.id">
                <pre>{{ JSON.stringify(claimant, null, 2) }}</pre>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchClaimants } from '../../modules/reward/firebase/index'

const claimants = ref([])

onMounted(async () => {
    claimants.value = await fetchClaimants()
})
</script>



